import { useState } from "react";
import { addToCartCookie, isTokenValid } from "../../../utility/Cookies";
import Swal from "sweetalert2";
import AddToCartFunc from "../../../utility/PublicComponent";
import { useLocation, useNavigate } from "react-router-dom";

export default function AddToCardProductDetailsComponent({ product,setData }) {
  const [LoadingAddToCart, setLoadingAddToCart] = useState(false);
  const [quantityState, setQuantity] = useState(1);
  const location = useLocation();
  const navigate = useNavigate();
  if (product) {
    const { id } = product;
    let quantity =
      product && product.inventory_of_product
        ? product.inventory_of_product.quantity
        : 0;

    const handleQuantityChange = (e) => {
      const value = e.target.value;

      if (!/^\d+$/.test(value)) {
        Swal.fire({
          text: `لطفا یک عدد معتبر وارد کنید.`,
          icon: "warning",
          confirmButtonText: "باشه",
        });
        return;
      }

      const newQuantity = parseInt(value, 10);

      if (newQuantity > quantity) {
        Swal.fire({
          text: `حداکثر تعداد مجاز ${quantity} می‌باشد.`,
          icon: "warning",
          confirmButtonText: "باشه",
        });
        setQuantity(quantity);
      } else setQuantity(newQuantity);
    };

    const addToCard = async () => {
      setLoadingAddToCart(true);
      await AddToCartFunc(
        id,
        quantityState,
        quantity,
        setQuantity,
        location,
        navigate,
        setData
      );
      setLoadingAddToCart(false);
    };
    return (
      <>
        <div className="product-attributes">
          <div>
            <div className="form-group product-quantity ml-2">
              <div className="input-group">
                <div className="input-group-prepend">
                  <span className="input-group-text product-quantity-text px-md-2">
                    تعداد
                  </span>
                </div>
                <input
                  type="text"
                  className="form-control product-quantity-input"
                  value={quantityState}
                  onChange={handleQuantityChange}
                />
              </div>
            </div>
          </div>
          {/* <div>
          <div className="form-group product-variant">
            <div className="input-group">
              <div className="input-group-prepend">
                <span className="input-group-text product-variant-text">
                  نوع
                </span>
              </div>
              <select
                id="variant"
                className="form-control product-variant-input"
                ng-disabled="progress"
              >
                <option
                  value={111623210}
                  data-stock={5}
                  data-price={238000000}
                  data-compare-price={0}
                  data-discount={0}
                >
                  primary
                </option>
              </select>
            </div>
          </div>
        </div> */}
        </div>
        <div>
          <button
            type="button"
            disabled={LoadingAddToCart}
            className="btn btn-green product-addtocart"
            onClick={LoadingAddToCart ? null : addToCard}
          >
            <svg
              width="1em"
              height="1em"
              viewBox="0 0 16 16"
              className
              fill="currentColor"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                d="M0 2.5A.5.5 0 0 1 .5 2H2a.5.5 0 0 1 .485.379L2.89 4H14.5a.5.5 0 0 1 .485.621l-1.5 6A.5.5 0 0 1 13 11H4a.5.5 0 0 1-.485-.379L1.61 3H.5a.5.5 0 0 1-.5-.5zM3.14 5l1.25 5h8.22l1.25-5H3.14zM5 13a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm-2 1a2 2 0 1 1 4 0 2 2 0 0 1-4 0zm9-1a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm-2 1a2 2 0 1 1 4 0 2 2 0 0 1-4 0z"
              ></path>
            </svg>
            افزودن به سبدخرید
          </button>
        </div>
        {/* loading */}
        <div className={LoadingAddToCart ? null : "d-none"} ng-show="progress">
          <i className="fa fa-refresh fa-spin fa-fw" />
          کمی صبر کنید...
        </div>
      </>
    );
  }
}
